import comp from "./ManageAccessForToddleLibrary";
export default comp;
